// GFF Prelegenci - popup z bio prelegenta (otwierany przyciskiem "więcej")
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.gff-speakers');
    var popup = document.querySelector('.gff-speaker-popup');
    if (!section || !popup) return;

    var photoEl = popup.querySelector('.gff-speaker-popup__img');
    var linkedinEl = popup.querySelector('.gff-speaker-popup__linkedin');
    var nameEl = popup.querySelector('.gff-speaker-popup__name');
    var roleEl = popup.querySelector('.gff-speaker-popup__role');
    var bioEl = popup.querySelector('.gff-speaker-popup__bio');
    var lastTrigger = null;

    function openPopup(card, trigger) {
      var img = card.querySelector('.gff-speakers__img');
      var linkedin = card.querySelector('.gff-speakers__linkedin');
      var name = card.querySelector('.gff-speakers__name');
      var role = card.querySelector('.gff-speakers__role');
      var bio = card.querySelector('.gff-speakers__bio');

      photoEl.src = img ? img.currentSrc || img.src : '';
      photoEl.alt = name ? name.textContent : '';
      nameEl.textContent = name ? name.textContent : '';
      roleEl.textContent = role ? role.textContent : '';
      bioEl.innerHTML = bio ? bio.innerHTML : '';

      if (linkedin) {
        linkedinEl.href = linkedin.href;
        linkedinEl.removeAttribute('hidden');
      } else {
        linkedinEl.setAttribute('hidden', '');
      }

      lastTrigger = trigger;
      popup.removeAttribute('hidden');
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      popup.querySelector('.gff-speaker-popup__close').focus();
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    section.querySelectorAll('.gff-speakers__more').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openPopup(btn.closest('.gff-speakers__card'), btn);
      });
    });

    // zdjęcie, imię i nazwisko oraz tytuł też otwierają popup
    // (z pominięciem linku LinkedIn, który ma nawigować normalnie)
    section.querySelectorAll('.gff-speakers__card').forEach(function (card) {
      ['.gff-speakers__photo', '.gff-speakers__name', '.gff-speakers__role'].forEach(function (sel) {
        var el = card.querySelector(sel);
        if (!el) return;
        el.addEventListener('click', function (e) {
          if (e.target.closest('.gff-speakers__linkedin')) return;
          var trigger = card.querySelector('.gff-speakers__more') || el;
          openPopup(card, trigger);
        });
      });
    });

    popup.querySelector('.gff-speaker-popup__close').addEventListener('click', closePopup);
    popup.querySelector('.gff-speaker-popup__overlay').addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hasAttribute('hidden')) closePopup();
    });
  });
})();
